import { createFileRoute } from '@tanstack/react-router';

import { ProviderQuotePage } from '@/features/services/provider/quotes-pages';

export const Route = createFileRoute('/_app/me/services/quotes/$responseId')({
  component: PageRoute,
});

function PageRoute() {
  const { responseId } = Route.useParams();
  return <ProviderQuotePage responseId={responseId} />;
}
